import { ConnectwareError, ConnectwareErrorType } from '../../domain'

import { Usecase } from './Usecase'

/** Remembers the width the user gave the record panel, in this browser */
export class RecordPanelWidthUsecase extends Usecase {
    private logFailure (e: unknown, message: string): void {
        this.logger.error(ConnectwareError.is(e) ? e : new ConnectwareError(ConnectwareErrorType.UNEXPECTED, message, { error: e }))
    }

    /** In px, `null` for the default width, also when the saved width can't be read */
    get (): number | null {
        try {
            return this.recordPanelWidthPersistenceService.retrieve()
        } catch (e: unknown) {
            this.logFailure(e, 'Could not read the record panel width')
            return null
        }
    }

    /** `null` goes back to the default width; a width that can't be saved is only kept by the caller */
    save (width: number | null): void {
        try {
            this.recordPanelWidthPersistenceService.persist(width)
        } catch (e: unknown) {
            this.logFailure(e, 'Could not save the record panel width')
        }
    }
}
